var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"isNecessary":1,"list":_vm.necessaryList,"readOnly":_vm.readOnly},on:{"set-list":_vm.setList}}),_c('Table',{attrs:{"isNecessary":0,"list":_vm.list,"readOnly":_vm.readOnly},on:{"set-list":_vm.setList}}),_c('Table',{attrs:{"isNecessary":2,"list":_vm.otherList,"readOnly":_vm.readOnly},on:{"set-list":_vm.setList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }